import { render, staticRenderFns } from "./protocol-zh.vue?vue&type=template&id=29ceeafe&scoped=true"
import script from "./protocol-zh.vue?vue&type=script&lang=js"
export * from "./protocol-zh.vue?vue&type=script&lang=js"
import style0 from "./protocol-zh.vue?vue&type=style&index=0&id=29ceeafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ceeafe",
  null
  
)

export default component.exports